import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { getSupportedTimezones, getTimezoneAbbreviation, getTimezoneLabel, getTimezoneUtcOffset } from '../../../../utils/date';
import { useDatePreferences } from '../../../hooks/useDatePreferences';
import SelectInput from './SelectInput';
export const BROWSER_TIMEZONE_OPTION = 'automatic';
export const resolveTimezoneOption = (value: string, browser_timezone: string) => !value || value === BROWSER_TIMEZONE_OPTION ? browser_timezone : value;
type Props = Omit<React.ComponentProps<typeof SelectInput>, 'options'> & {
  compact_browser_default?: boolean;
};
const TimezoneSelectInput: React.FC<Props> = t0 => {
  const $ = _c(15);
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      compact_browser_default: t1,
      label: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const compact_browser_default = t1 === undefined ? false : t1;
  const label = t2 === undefined ? "Timezone" : t2;
  const {
    browser_timezone
  } = useDatePreferences();
  let t3;
  if ($[4] !== browser_timezone || $[5] !== compact_browser_default) {
    const now = new Date();
    const browser_timezone_abbreviation = getTimezoneAbbreviation(browser_timezone, now);
    const browser_timezone_offset = getTimezoneUtcOffset(browser_timezone, now);
    const t4 = `Browser default (${browser_timezone_abbreviation}, ${browser_timezone_offset})`;
    const t5 = compact_browser_default ? `${browser_timezone_abbreviation} (${browser_timezone_offset})` : undefined;
    let t6;
    if ($[7] !== browser_timezone || $[8] !== t4 || $[9] !== t5) {
      t6 = {
        value: BROWSER_TIMEZONE_OPTION,
        label: t4,
        selected_label: t5,
        description: browser_timezone
      };
      $[7] = browser_timezone;
      $[8] = t4;
      $[9] = t5;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t3 = [t6, ...getSupportedTimezones().map(timezone => ({
      value: timezone,
      label: getTimezoneLabel(timezone, now),
      description: timezone,
      selected_label: getTimezoneLabel(timezone, now)
    }))];
    $[4] = browser_timezone;
    $[5] = compact_browser_default;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const timezone_options = t3;
  let t4;
  if ($[11] !== label || $[12] !== props || $[13] !== timezone_options) {
    t4 = <SelectInput block={true} search={true} label={label} options={timezone_options} search_placeholder="Search timezones..." {...props} />;
    $[11] = label;
    $[12] = props;
    $[13] = timezone_options;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
export default TimezoneSelectInput;